import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { buildLocationUrl, locationLabel } from '../../utils/locationLink';

const EventDetails = (props) => {
    const event = props.data.find(({_id}) => _id === props.eventId)
    return (
        <div>
        <Modal isOpen={props.modal} toggle={props.toggleEventDetails}>
            <ModalHeader toggle={props.toggleEventDetails}><b>Event Details</b></ModalHeader>
            <ModalBody>
                <h6><b>Event Description</b></h6>
                <p style={{whiteSpace: "pre-wrap"}}>{event?event.description:<i>Select Event Date</i>}</p> 
                <h6><b>Difficulty Level</b></h6>       
                <p>{event?event.difficulty:<i>Select Event Date</i>}</p>
                {event&&event.location?<Fragment><h6><b>Location</b></h6><a href={buildLocationUrl(event.location, event.locationPlaceId)} target='_blank' rel='noreferrer'>{locationLabel(event.location)}</a></Fragment>:null}
            </ModalBody>
        </Modal>
        </div>
    );
}

export default EventDetails;